import { useUserDetailHeader } from './hooks';
import { UserDetailHeaderPresentation } from './presentations';

type Props = {
  /** 利用者ID */
  userId: number;
};

/**
 * 利用者詳細ヘッダー Container
 *
 * - API から氏名を取得してパンくずリストを表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const UserDetailHeader: React.FC<Props> = ({ userId }) => {
  const {
    state: { data },
  } = useUserDetailHeader(userId);

  return <UserDetailHeaderPresentation fullName={data.user.full_name} />;
};
